import { render, staticRenderFns } from "./file-select.vue?vue&type=template&id=aa6bed62&"
import script from "./file-select.vue?vue&type=script&lang=js&"
export * from "./file-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('aa6bed62', component.options)
    } else {
      api.reload('aa6bed62', component.options)
    }
    module.hot.accept("./file-select.vue?vue&type=template&id=aa6bed62&", function () {
      api.rerender('aa6bed62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/components/file-select/file-select.vue"
export default component.exports